import RDSPlayer from './RDSPlayer.js';
import { eventBus, EVENTS } from "./EventBus.js";
const REFRESH_PREROLL_HOURS=[10,11,14,15,16,17];
const REFRESH_PREROLL_INTERVAL= 60 * 10 * 1000;
let lastPreroll=new Date().getTime();
window.radioId = 1;

let sources = [
  {
    audio: true,
    live: true,
    type: "application/x-mpegurl",
    src: window.streamurl //'https://stream.rds.radio/audio/rds.stream_aac/playlist.m3u8', //'https://stream.rds.radio/rds.stream_aac/playlist.m3u8',
  },
  {
    audio: true,
    live: true,
    type: "audio/mp3",
    src: "https://icstream.rds.radio/rds"
  }
];
let sourcesSerieA = [
  {
    audio: true,
    live: true,
    type: "application/x-mpegurl",
    src: 'https://stream.rds.radio/audio/seriea.stream_aac/chunklist.m3u8',
  },
  {
    audio: true,
    live: true,
    type: "audio/mp3",
    src:''// "https://icstream.rds.radio/rds"
  }
];


$(document).ready(function () {

  let cachebusterAudio = Math.floor((Math.random() * 1000000) + 1);
  let cachebusterVideo = Math.floor((Math.random() * 1000000) + 1);
  // window.urlAudioPreroll = "https://ad89.neodatagroup.com/ad/rds.jsp?sid=89&loc=rsn_rds_diretta_diretta_audio&fmt=&fmtpos=&keyw=&jsfunc=&bt=n&wt=n&rnd=" + cachebusterAudio;
  // window.urlAudioPreroll="https://rds.deliveryengine.adswizz.com/vast/4.0/request/alias/radio_dimensione-suono-rds";
  window.urlAudioPreroll="https://rds.deliveryengine.adswizz.com/vast/4.0/request/alias/radio_dimensione-suono-rds";
  //
  //https://rds.deliveryengine.adswizz.com/vast/4.0/request/alias/Test_video_preroll
    // window.urlAudioPreroll = 'https://rds.deliveryengine.adswizz.com/vast/4.0/request/alias/test-zone-rds';

  window.urlVideoPreroll = 'https://rds.deliveryengine.adswizz.com/vast/4.0/request/alias/radio_dimensione_suono_video';

  // window.urlAudioPreroll=false;
  let imaDiretta=window.urlAudioPreroll;
  if(true || getDeviceType()=='Desktop'){
    imaDiretta=[window.urlVideoPreroll, window.urlAudioPreroll];
  }
  window.mainPlayer = new RDSPlayer({ container: '#diretta-play', ima: imaDiretta, sources: sources, isLive: true });
  window.playerPodcast = new RDSPlayer({ container: '#podcast-play',ima: window.urlAudioPreroll, sources: [{ type: "audio/mp3", src: 'https://web.rds.it/m/a24540d' }], isLive: false });
  window.videoPlayer = new RDSPlayer({ container: '#videoplayer', ima: imaDiretta, sources: [], isLive: false });

  // INIZIO INTEGRAZIONE SENSIC

  var gfkS2sConf =   {
    media: 'rds_web',
    url: '//it-config.sensic.net/s2s-web.js',   //it for production
    //url:    "//[RegionId]-config.sensic.net/s2s-web.js", // for production
    type: 'WEB',
    crashReporting: true   //poi decidere se false
  };
  window.mainPlayer.playerConf = {
    instance: window.mainPlayer.container,
    vendor: 'html5',
    type: 'live'
  }

  window.playerPodcast.playerConf = {
    instance: window.playerPodcast.container,
    vendor: 'html5',
    type: 'vod'
  }

  window.videoPlayer.playerConf = {
    instance: window.videoPlayer.container,
    vendor: 'html5',
    type: 'live'
  }


  window.mainPlayer.contentMetadata = {
    customParams : {
      channel: 'rds',
      format: 'audio',
      type: 'live'
    }
  }

  window.playerPodcast.contentMetadata = {
    customParams: {
      channel: '',
      format: 'audio',
      type: 'podcast'
    }
  }

  window.videoPlayer.contentMetadata = {
    customParams:{
      channel: 'rds',
      format: 'video',
      type: 'live'
    }
  }

  // var extensionMain;
  // var extensionPodcast;
  // var extensionVideo;

  var script = document.createElement('script');
  script.setAttribute("crossorigin", "anonymous");
  // script.src = '//demo-config.sensic.net/playerextension.js';
  script.src = '//it-config.sensic.net/playerextension.js';
  document.head.appendChild(script);

  script.onload = function() {
    // Bind your player to the SENSIC S2S measurement SDK
    window.extensionMain = new window.gfkS2sExtension.PlayerExtension(window.mainPlayer.playerConf, gfkS2sConf, window.mainPlayer.contentMetadata);
    window.extensionPodcast = new window.gfkS2sExtension.PlayerExtension(window.playerPodcast.playerConf, gfkS2sConf, window.playerPodcast.contentMetadata);
    window.extensionVideo = new window.gfkS2sExtension.PlayerExtension(window.videoPlayer.playerConf, gfkS2sConf, window.videoPlayer.contentMetadata);

  };


  // FINE INTEGRAZIONE SENSIC

  function getDeviceType() {
    const width = $(window).width();
    let deviceType = '';
    if (width >= 1280) {
      deviceType = 'Desktop';
    }
    else if (width >= 768 && width < 1280) {
      deviceType = 'Tablet';
    } else {
      deviceType = 'Mobile';
    }
    return deviceType;
  }

  mainPlayer.on('metadata', (e) => {
    console.log('metadata', e);
    if(e && e.type=='spot'){
      const now=new Date();
      if(REFRESH_PREROLL_HOURS.indexOf(now.getHours())!=-1 && now.getTime()-lastPreroll > REFRESH_PREROLL_INTERVAL){
        lastPreroll=now.getTime();
        mainPlayer.restartPreroll()
      }
    }
  });
  initPlayerListeners();
});

function initPlayerListeners() {
  mainPlayer.on('resume', () => {
    console.log('res');
    $('header .player-icon').addClass('is-playing');
    videoPlayer.stop();
  });
  mainPlayer.on('pause', () => {
    $('header .player-icon').removeClass('is-playing');
  });

  videoPlayer.on('resume', () => {
    mainPlayer.stop();
  });

  videoPlayer.on('sourcechange', (e) => {
    console.log('e',e);
    if (e.oldSource == window.videoStream && e.newSource != window.videoStream) {
      stopVideoDiretta();
    }
  })
}

function toggleDiretta() {
  if (!window.mainPlayer.playing()) {
    stopVideoDiretta();

    window.mainPlayer.play();
    eventBus.emit(EVENTS.LIVE_PLAY);
    // $('#direttaplaybutton').html('Stop');
  } else {
    window.mainPlayer.stop();
    eventBus.emit(EVENTS.LIVE_PAUSE);
    // $('#direttaplaybutton').html('Play');
  }
}

function stopVideoDiretta() {
  document.rdsExitPip();
  videoPlayer.stop();
  $('#videoplayer').hide();
  $('#videoplayer').removeClass('pip');
  $('.player-video').removeClass('is-playing');
}

function toggleDirettaVideo() {

  if ($(".player-video").hasClass("is-playing")) {
    videoPlayer.pause();
  } else {
    if(videoPlayer.getSource()!=window.videoStream){
      videoPlayer.setSource(window.videoStream);
    }
    $('#videoplayer').addClass('pip');
    videoPlayer.play();
    // $('#player_bottom').show();
    $(".player-video").addClass("is-playing");

    // videoPlayer.on('play',async()=>{

      setTimeout(async ()=>{
        await videoPlayer.container.rdsPip();
        videoPlayer.container.setAttribute("controls","controls");
        const containeradv = document.getElementById('rds-ad-container');
        if(containeradv.innerHTML){
          const btnToggleRadios = document.getElementById('btnGuardaSerieAWrapper');
          btnToggleRadios.classList.add('btn_guarda_seriea-disabled');
        }

      }, 500);

    // });


  }

  videoPlayer.on('pause', () => {
    $(".player-video").removeClass("is-playing");
  });
  videoPlayer.on('play', () => {
    $(".player-video").addClass("is-playing");
  });
}



function toggleAudioVideoPlayer(type) {

  if (type == 1) {

    $("#red_part").removeClass("extended");
    $("#blue_part").addClass("extended");

    // TO REVIEW
    // setTimeout(function () {

    //   toggleAudioVideoPlayer(0);
    // }, 7000);

  } else {

    $("#blue_part").removeClass("extended");
    $("#red_part").addClass("extended");

  }

}

function changeRadio(radio){
  console.log('clicked',radio);
  if(radio == 1){
    $("#info-song-seriea").removeClass("display-none");
    // banner.removeChild(banner_serieA);
    $('#player-radio-serie').removeClass('player-text-btns-clicked');
    $('#player-radio-rds').addClass('player-text-btns-clicked');
    // $('#player-radio-dropdown').removeClass('player-dropdown-disabled');
    $('#banner-rds').removeClass('hide_banner');
    $('#banner-seriea').addClass('hide_banner');
    if (window.innerWidth <= 650) {
      $(".container_player").removeClass("collapsed");
      $("#blocco_player").removeClass("collapsed");   }


    window.mainPlayer.setSources(sources);
    window.urlAudioPreroll = 'https://rds.deliveryengine.adswizz.com/vast/4.0/request/alias/radio_dimensione-suono-rds';
    window.urlVideoPreroll = 'https://rds.deliveryengine.adswizz.com/vast/4.0/request/alias/radio_dimensione_suono_video';
    window.videoStream = 'https://stream.rdstv.radio/index.m3u8';
    window.radioId = 1;
    window.extensionVideo.setParameter({customParams:{ channel: 'rds', format: 'video', type:'live' }});
    window.extensionMain.setParameter({customParams:{ channel: 'rds', format: 'audio', type:'live' }});
  }
  if(radio == 13){
    // $('#player-radio-dropdown').addClass('player-dropdown-disabled');
    // banner.removeChild(banner_rds);
    $(".container_player").addClass("collapsed");
    $('#player-radio-rds').removeClass('player-text-btns-clicked');
    $('#player-radio-serie').addClass('player-text-btns-clicked');
    $('#banner-seriea').removeClass('hide_banner');
    $('#banner-rds').addClass('hide_banner');
    window.mainPlayer.setSources(sourcesSerieA);
    window.urlAudioPreroll = 'https://rds.deliveryengine.adswizz.com/vast/4.0/request/alias/Radio_Serie_A_con_RDS_preroll';
    window.urlVideoPreroll = 'https://rds.deliveryengine.adswizz.com/vast/4.0/request/alias/RadioSerieA_video';
    window.videoStream = 'https://stream.radioseriea.com/50773f0d0070476a8612d9984c6059d8/index.m3u8';
    window.radioId = 13;
    window.extensionVideo.setParameter({customParams:{ channel: 'seriea', format: 'video', type:'live' }});
    window.extensionMain.setParameter({customParams:{ channel: 'seriea', format: 'audio', type:'live' }});

    if (window.innerWidth < 710) {
      $("#info-song-seriea").addClass("display-none");
      $("#info-song-seriea-mobile").removeClass("display-none");
    } else {
      $("#info-song-seriea").removeClass("display-none");
      $("#info-song-seriea-mobile").addClass("display-none");
    }
  }
  window.mainPlayer.ima = [window.urlVideoPreroll,window.urlAudioPreroll];
  window.videoPlayer.ima = [window.urlVideoPreroll,window.urlAudioPreroll];
  // window.mainPlayer.stop();
  if (window.mainPlayer.playing()){
    window.mainPlayer.restartPreroll();
  }
  // window.mainPlayer.play();

  $("#blocco_player").show();
}

// function onleavepictureinpicture(e) {
//   // if (HTMLVideoElement.prototype.webkitSetPresentationMode && playerPodcast.container.webkitPresentationMode == 'picture-in-picture') {
//   //   return;
//   // } else if (HTMLVideoElement.prototype.webkitSetPresentationMode) {
//   //   playerPodcast.container.onwebkitpresentationmodechanged = null;
//   // }
//   playerPodcast.pause();
//   stopVideoDiretta()
//   $(".player-video").removeClass("is-playing");

//   setTimeout(function () {
//     if (!document.pictureInPictureElement&&!document.rdspictureInPictureElement) {
//       toggleAudioVideoPlayer(0);
//     }
//   }, 7000);
// };


async function apriPictureInPiture(){

  if (!HTMLVideoElement.prototype.webkitSetPresentationMode) {
    await videoPlayer.container.requestPictureInPicture();
  } else {
    videoPlayer.container.webkitSetPresentationMode('picture-in-picture');
  }

}

window.apriPictureInPiture = apriPictureInPiture;
window.toggleDiretta = toggleDiretta;
window.toggleDirettaVideo = toggleDirettaVideo;
window.stopVideoDiretta = stopVideoDiretta;
window.toggleAudioVideoPlayer = toggleAudioVideoPlayer;
window.changeRadio = changeRadio;
